import {
  createStyles,
  makeStyles,
  Theme,
  useMediaQuery
} from "@material-ui/core";

export default makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      height: "100vh",
      maxWidth: "80vw",
      paddingTop: "1rem"
    },
    paper: {
      padding: theme.spacing(2),
      textAlign: "center",
      color: theme.palette.text.secondary
    },

    title: {
      margin: theme.spacing(2),
      marginBottom: theme.spacing(4)
    },
    section: {
      margin: `${theme.spacing(2)} !important`,
      [theme.breakpoints.down("sm")]: {
        marginLeft: 0,
        marginRight: 0
      }
    },
    pr: {
      [theme.breakpoints.only("md")]: {
        paddingRight: "0.5rem"
      }
    },
    pl: {
      [theme.breakpoints.only("md")]: {
        paddingLeft: "0.5rem"
      }
    },
    pb: {
      paddingBottom: "1rem"
    },
    totalSalesKpi: {
      paddingBottom: "1rem",
      [theme.breakpoints.between("md", 1280)]: {
        paddingRight: "0.5rem"
      }
    },
    conversionRateKpi: {
      [theme.breakpoints.between("md", 1280)]: {
        paddingLeft: "0.5rem"
      }
    },
    spinnerContainer: {
      position: "absolute",
      backgroundColor: "rgba(255,255,255,0.8)",
      zIndex: 100,
      left: 0,
      top: 0,
      width: "100%",
      height: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500]
    }
  })
);
